import type { RpgClassId } from '@yuan-math/learning';

/**
 * The five classes, as copy.
 *
 * One playful line each and nothing more, because a class is a costume
 * (docs/rpg.md §10): the drawings live in `packages/ui`, the id lives on the
 * profile, and no line here may ever describe an ability.
 */
export const RPG_CLASSES: readonly { id: RpgClassId; emoji: string; name: string; line: string }[] = [
  { id: 'wizard', emoji: '🧙', name: 'Wizard', line: 'Turns hard problems into spells, and spells into answers.' },
  { id: 'knight', emoji: '⚔️', name: 'Knight', line: 'Meets the toughest question head on, and does not flinch.' },
  { id: 'ranger', emoji: '🏹', name: 'Ranger', line: 'Explores every corner of the map and always finds a path.' },
  { id: 'engineer', emoji: '🛠️', name: 'Engineer', line: 'Builds an answer one careful, well-fitted piece at a time.' },
  { id: 'scientist', emoji: '🔬', name: 'Scientist', line: 'Experiments, measures twice, and lets the numbers decide.' },
];

export function classNameOf(id: RpgClassId | undefined): string {
  return RPG_CLASSES.find((entry) => entry.id === id)?.name ?? 'Adventurer';
}
